import React, { useLayoutEffect, useState } from 'react';
import { CButton, CForm, CFormInput, CFormLabel, CFormSelect } from '@coreui/react';
import Swal from "sweetalert2";
import axios from 'axios';
import ReactLoading from 'react-loading';
import Select from 'react-select'
import './Bebidas.css'

let uploadLabelStyle = { display: 'inline-block', padding: '10px 15px', backgroundColor: 'rgb(118, 133, 161)', color: 'white', borderRadius: '5px', cursor: 'pointer', width: '200px', };
let previewStyle = { maxWidth: '50px', maxHeight: '50px', minWidth: '50px', minHeight: '50px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.1)', };

function FileInput({ id, label, onFile, preview }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
      <input type="file" style={{ display: 'none' }} id={id} onChange={(e) => onFile(e.target.files[0])} />
      <label htmlFor={id} style={uploadLabelStyle}>
        <i className="fa-solid fa-cloud-arrow-up"></i> {label}
      </label>
      {preview && <img src={preview} alt="Preview" style={previewStyle} />}
    </div>
  );
}

function Input({ label, value, set }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', width: '30%' }}>
      <CFormLabel style={{ fontSize: '10px' }}>{label}</CFormLabel>
      <CFormInput placeholder={label} style={{ "maxWidth": "400px", minWidth: "300px" }} value={value} className='col' type="text" onChange={(e) => { set(e.target.value) }} />
    </div>
  );
}

function ArrayInput({ title, label, array, set }) {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
        <span style={{ fontWeight: "bold", fontSize: "15px", }}>{title}</span>
      </div>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }}>
        {array.map((valor, index) => {
          let isLast = index === array.length - 1;
          let canAdd = array.length < 4;
          let canRemove = array.length > 1;

          return (
            <div key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
              <CFormInput placeholder={`${label} #${index + 1}`} value={valor} onChange={e => { let nuevas = [...array]; nuevas[index] = e.target.value; set(nuevas); }} style={{ minWidth: "350px", maxWidth: "350px" }} />
              {isLast && canAdd ? (
                <CButton shape='rounded-pill' size="sm" color="success" onClick={() => set([...array, ""])}><i className="fa-solid fa-plus"></i></CButton>
              ) : (canRemove && (
                <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => { let nuevas = [...array]; nuevas.splice(index, 1); set(nuevas); }}><i className="fa-solid fa-minus"></i></CButton>
              )
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

function ArrayInputTimes({ title, array, set }) {
  const dias = [
    { value: 0, label: "Domingo" },
    { value: 1, label: "Lunes" },
    { value: 2, label: "Martes" },
    { value: 3, label: "Miércoles" },
    { value: 4, label: "Jueves" },
    { value: 5, label: "Viernes" },
    { value: 6, label: "Sábado" }
  ]

  const handleChange = (index, field, value) => {
    let nuevas = [...array]
    nuevas[index] = { ...nuevas[index], [field]: value }
    set(nuevas)
  }

  const empty = { dia: 1, inicio: "09:00", fin: "17:00" }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
        <span style={{ fontWeight: "bold", fontSize: "15px" }}>{title}</span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
        {array.map((horario, index) => {
          let isLast = index === array.length - 1
          let canAdd = array.length < 100
          let canRemove = array.length > 1

          return (
            <div key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>

              {/* Día */}
              <CFormSelect
                value={horario.dia}
                onChange={e => handleChange(index, "dia", Number(e.target.value))}
                style={{ minWidth: "140px", maxWidth: "140px" }}
              >
                {dias.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
              </CFormSelect>

              {/* Hora inicio */}
              <CFormInput
                type="time"
                value={horario.inicio}
                onChange={e => handleChange(index, "inicio", e.target.value)}
                style={{ minWidth: "130px", maxWidth: "130px" }}
              />

              <span style={{ fontWeight: "bold" }}>a</span>

              {/* Hora fin */}
              <CFormInput
                type="time"
                value={horario.fin}
                onChange={e => handleChange(index, "fin", e.target.value)}
                style={{ minWidth: "130px", maxWidth: "130px" }}
              />

              {/* Botones */}
              {isLast && canAdd ? (
                <CButton shape='rounded-pill' size="sm" color="success" onClick={() => set([...array, { ...empty }])}>
                  <i className="fa-solid fa-plus"></i>
                </CButton>
              ) : canRemove && (
                <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => { let nuevas = [...array]; nuevas.splice(index, 1); set(nuevas) }}>
                  <i className="fa-solid fa-minus"></i>
                </CButton>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}

function BannersInput({ banners, setBanners }) {
  const MAX = 4

  const handleFile = (e, index) => {
    let file = e.target.files[0]
    if (!file) return
    let nuevos = [...banners]
    nuevos[index] = file
    setBanners(nuevos)
  }

  const agregar = () => { if (banners.length < MAX) setBanners([...banners, null]) }
  const eliminar = (index) => { let nuevos = [...banners]; nuevos.splice(index, 1); setBanners(nuevos) }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
        <span style={{ fontWeight: "bold", fontSize: "15px" }}>Banners</span>
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
        {banners.map((archivo, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input type="file" accept=".jpg,image/jpeg" id={`banner-${index}`} style={{ display: "none" }}
              onChange={e => handleFile(e, index)} />
            <label htmlFor={`banner-${index}`} style={uploadLabelStyle}>
              <i className="fa-solid fa-cloud-arrow-up"></i> Banner {index + 1}
            </label>
            {archivo && <img src={URL.createObjectURL(archivo)} style={previewStyle} />}
            <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => eliminar(index)}>
              <i className="fa-solid fa-minus"></i>
            </CButton>
          </div>
        ))}
        {banners.length < MAX && (
          <CButton shape='rounded-pill' size="sm" color="success" onClick={agregar}>
            Agregar banner&nbsp;<i className="fa-solid fa-plus"></i>
          </CButton>
        )}
      </div>
    </>
  )
}

function PDFInput({ menuPDF, setMenuPDF, setPreviewPDFName }) {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "12px", marginBottom: "12px" }}>
        <span style={{ fontWeight: "bold", fontSize: "15px" }}>Menú PDF</span>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
        <input type="file" accept=".pdf,application/pdf" id="uploadPDF" style={{ display: "none" }}
          onChange={(e) => {
            let file = e.target.files[0]
            if (!file) return
            setMenuPDF(file)
            setPreviewPDFName(file.name)
          }} />
        <label htmlFor="uploadPDF" style={uploadLabelStyle}>
          <i className="fa-solid fa-file-pdf"></i> {menuPDF ? 'Cambiar PDF' : 'Subir menú PDF'}
        </label>
        {menuPDF && (
          <>
            <span style={{ fontSize: "13px", color: "gray" }}>{menuPDF.name}</span>
            <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => { setMenuPDF(null); setPreviewPDFName(null) }}>
              <i className="fa-solid fa-xmark"></i>
            </CButton>
          </>
        )}
      </div>
    </>
  )
}

function InsertRestaurante({ setVisible, restaurantes, setRestaurantes }) {
  let [loading, setLoading] = useState(false);
  let [progress, setProgress] = useState(0);
  let [previewLogo, setPreviewLogo] = useState(null);
  let [previewImg, setPreviewImg] = useState(null);
  let [nombre, setNombre] = useState('');
  let [type, setType] = useState('');
  let [address, setAddress] = useState('');
  let [tel, setTel] = useState('');
  let [email, setEmail] = useState('');
  let [whatsapp, setWhatsapp] = useState('');
  let [condiciones, setCondiciones] = useState('');
  let [condiciones2, setCondiciones2] = useState('');
  let [googleMapsURL, setGoogleMapsURL] = useState('');
  let [latLong, setLatLong] = useState('');
  let [logo, setLogo] = useState(null);
  let [img, setImg] = useState(null);
  let [times, setTimes] = useState([""]);
  let [timesPromo, setTimesPromo] = useState([{ dia: 1, inicio: "09:00", fin: "17:00" }])
  let [redes, setRedes] = useState([""]);
  let [drinks, setDrinks] = useState([""]);
  let [selectedDrinks, setSelectedDrinks] = useState([]);
  let [banners, setBanners] = useState([]);
  let [menuPDF, setMenuPDF] = useState(null)
  let [previewPDFName, setPreviewPDFName] = useState(null)

  function identificarRedSocial(url) {
    if (/instagram\.com/.test(url)) return "instagram";
    if (/facebook\.com/.test(url)) return "facebook";
    if (/x\.com|twitter\.com/.test(url)) return "x";
    if (/youtube\.com|youtu\.be/.test(url)) return "youtube";
    return "unknown";
  }

  // Función para manejar las imágenes
  function handleFile(e, setter, setPreview) {
    let file = e.target.files[0];
    setter(file);
    if (file) setPreview(URL.createObjectURL(file));
  }

  // Funciones de validación
  function validarTel(tel) {
    return /^[0-9]{10,}$/.test(tel); // 10 o más dígitos
  }

  function validarWhatsapp(whatsapp) {
    return /^[0-9]{10,}$/.test(whatsapp); // 10 o más dígitos
  }

  function validarCorreo(email) {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  }

  function validarURL(url) {
    return /^https?:\/\/.+/.test(url); // http:// o https://
  }

  function validarLatLong(ll) {
    return /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(ll); // 19.4326,-99.1332
  }


  function validarImagen(imagen) {
    if ((imagen.type !== "image/jpeg") || imagen.size > 400000) { // si el archivo pesa mas de 400kb y es tipo diferente a .jpg
      Swal.fire({
        icon: "error",
        title: "Verifica tu imagen",
        text: "Solo se permiten imágenes tipo .jpg y máximo de 400kb.",
        footer: `Esta es de tipo .${imagen.type.split("/")[1]} y pesa ${(imagen.size / 1024).toFixed(2)}kb.`,
        confirmButtonText: "Entendido",
        confirmButtonColor: "rgb(118, 133, 161)",
      })
      return false;
    }
    return true;
  }

  async function subirImagenACloudinary(archivo, nombreImagen, folder, tags) {
    if (!(validarImagen(archivo))) { // si la imagen es inválida
      throw new Error("Imagen inválida");
    }

    return new Promise((resolve, reject) => {
      let img = new Image();
      img.src = URL.createObjectURL(archivo);

      img.onload = async () => {
        if (false) {
          // if (img.width < 300 || img.height < 300) { // si la imagen mide mínimo 300x300
          Swal.fire(`La imagen debe medir mínimo 300x300px. Esta tiene ${img.width}x${img.height}`);
          reject();
        } else {
          let formData = new FormData();
          formData.append("file", archivo);
          formData.append("upload_preset", "upload_bebbo_restaurante");
          formData.append("user", tags);
          formData.append("folder", folder);
          formData.append("public_id", nombreImagen);
          try {
            let res = await axios.post(
              `${process.env.REACT_APP_BackURL}/upMedia`,
              formData,
              {
                onUploadProgress: (e) => {
                  let percent = Math.round((e.loaded * 100) / e.total);
                  setProgress(percent);
                }
              }
            );
            resolve(res.data.secure_url);
          } catch (err) {
            reject(err);
          }
        }
      };
    });
  };

  async function subirPDFACloudinary(archivo, nombreArchivo, folder, tags) {
    if (archivo.type !== 'application/pdf') {
      Swal.fire({ icon: "error", title: "Archivo inválido", text: "Solo se permiten archivos PDF." })
      throw new Error("Archivo inválido")
    }

    let formData = new FormData()
    formData.append("file", archivo)
    formData.append("public_id", nombreArchivo)

    let res = await axios.post(`${process.env.REACT_APP_BackURL}/uppdf`, formData, {
      onUploadProgress: (e) => {
        let percent = Math.round((e.loaded * 100) / e.total)
        setProgress(percent)
      }
    })

    return res.data.url // 👈 URL de Google Drive
  }

  async function handleSubmit() {
    // Solo nombre y correo son obligatorios
    if (!nombre || !email) {
      Swal.fire("Nombre y correo son obligatorios");
      return;
    }

    if (tel && !validarTel(tel)) {
      Swal.fire("Teléfono inválido (solo números, mínimo 10 dígitos)");
      return;
    }

    if (whatsapp && !validarWhatsapp(whatsapp)) {
      Swal.fire("WhatsApp inválido (solo números, mínimo 10 dígitos)");
      return;
    }
    if (!validarCorreo(email)) {
      Swal.fire("Correo inválido");
      return;
    }

    if (googleMapsURL && !validarURL(googleMapsURL)) {
      Swal.fire("URL de Google Maps inválida");
      return;
    }

    if (latLong && !validarLatLong(latLong)) {
      Swal.fire("Formato de coordenadas inválido. Usa: 19.4326,-99.1332");
      return;
    }

    try {
      setLoading(true);

      let data = {
        name: nombre,
        type,
        address,
        tel,
        email,
        whatsapp,
        condiciones,
        condiciones2,
        googleMapsURL,
        latLong: latLong ? latLong.replace(/\s+/g, '') : '',
        isActive: true,
        published: false,
        times,
        timesPromo,
        drinks: selectedDrinks,
        redes: redes.filter((r) => r.trim() !== "").map((url) => {
          let key = identificarRedSocial(url);
          return { [key]: url };
        }),
      };

      let response = await axios.post(`${process.env.REACT_APP_BackURL}/insertRestaurant`, data);

      let mongoID = response.data.data._id;

      let folderImg = `bebbo/restaurante`
      let folderLogo = `bebbo/logo`

      let logoUrl = logo && await subirImagenACloudinary(logo, `logo${mongoID}`, folderLogo, mongoID);
      let imgUrl = img && await subirImagenACloudinary(img, `banner${mongoID}`, folderImg, mongoID);

      let bannersUrls = []
      for (let i = 0; i < banners.length; i++) {
        let url = await subirImagenACloudinary(banners[i], `banner${mongoID}_${i}`, folderImg, mongoID)
        bannersUrls.push(url)
      }

      if (bannersUrls.length > 0) {
        await axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${mongoID}`, { banners: bannersUrls })
        response.data.data.banners = bannersUrls
      }

      if (menuPDF) {
        let pdfUrl = await subirPDFACloudinary(menuPDF, `menu${mongoID}`, `bebbo/menus`, mongoID)
        await axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantById?id=${mongoID}`, { menuPDF: pdfUrl })
        response.data.data.menuPDF = pdfUrl
      }

      if (logoUrl) { response.data.data.logo = logoUrl; }
      if (imgUrl) { response.data.data.img = imgUrl; }

      setRestaurantes([...restaurantes, response.data.data]);
      Swal.fire("Restaurante registrado con éxito");
      setVisible(false);
    } catch (err) {
      console.error(err);
      Swal.fire("Error al registrar restaurante");
    } finally {
      setLoading(false);
    }
  };

  function getBebidas() {
    axios.get(`${process.env.REACT_APP_BackURL}/getAllDrinks`)
      .then((response) => {
        let temp = []
        response.data.data.forEach((drink) => { temp.push({ value: drink._id, label: `${drink.name.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}` }) })
        setDrinks(temp);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  useLayoutEffect(() => {
    getBebidas();
  }, []);

  return (
    <>
      <CForm>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }} >

          <Input label="Nombre" value={nombre} set={setNombre} />

          <Input label="Palabras para busqueda o filtros" value={type} set={setType} />

          <Input label="Dirección" value={address} set={setAddress} />

          <Input label="Teléfono" value={tel} set={setTel} />

          <Input label="Correo" value={email} set={setEmail} />

          <Input label="WhatsApp" value={whatsapp} set={setWhatsapp} />

          <Input label="Descripción del restaurante" value={condiciones} set={setCondiciones} />

          <Input label="Condiciones de uso" value={condiciones2} set={setCondiciones2} />

          <Input label="Google Maps URL" value={googleMapsURL} set={setGoogleMapsURL} />

          <Input label="Latitud,Longitud" value={latLong} set={(text) => setLatLong(text.replace(/\s/g, ""))} />

          {/* <div>
            <h6 style={{ textAlign: 'center' }}>Agregar bebidas</h6>
            <Select className='select' placeholder="Buscar bebidas" options={drinks} onChange={(e) => { setSelectedDrinks([...selectedDrinks, e.value]) }} />
          </div> */}
        </div>


        <div
          style={{ maxWidth: "400px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "8px", marginTop: "16px", }}>
          {selectedDrinks.map((id) => {
            const drink = drinks.find((d) => d.value === id);
            if (!drink) return null;

            return (
              <div key={id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", border: "1px solid #e4e6eb", borderRadius: "8px", backgroundColor: "#f8f9fa", }}>
                <span style={{ fontWeight: 600, fontSize: "14px" }}>{drink.label}</span>
                <CButton shape='rounded-pill' size="sm" color="danger" onClick={() => setSelectedDrinks(selectedDrinks.filter((d) => d !== id))}><i className="fa-solid fa-xmark" /></CButton>
              </div>
            );
          })}
        </div>

        <ArrayInput title="Redes sociales" label="Red social" array={redes} set={setRedes} />

        <ArrayInput title="Horarios restaurante" label="Horario" array={times} set={setTimes} />

        <ArrayInputTimes title="Horarios promoción" array={timesPromo} set={setTimesPromo} />

        <BannersInput banners={banners} setBanners={setBanners} />

        <PDFInput menuPDF={menuPDF} setMenuPDF={setMenuPDF} setPreviewPDFName={setPreviewPDFName} />

        <br />

        {/* Imagen principal */}
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }} >
          <FileInput label="Imagen del lugar" id="uploadImg" onFile={(file) => { if (validarImagen(file)) { handleFile({ target: { files: [file] } }, setImg, setPreviewImg) } }} preview={previewImg} />
        </div>

        <br />

        {/* Logo */}
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: "2vw" }}>
          <FileInput label="Logo" id="uploadLogo" onFile={(file) => { if (validarImagen(file)) { handleFile({ target: { files: [file] } }, setLogo, setPreviewLogo) } }} preview={previewLogo} />
        </div>

        <span style={{ fontWeight: "bold", fontSize: "15px", display: "flex", justifyContent: "center", marginTop: "10px" }}>La imágenes deben ser tipo .jpg y máximo 400kb</span>

      </CForm>

      <br />
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
          <ReactLoading type="spin" color="cornflowerblue" height={'3vw'} width={'3vw'} />
          <p style={{ fontSize: '2vw', color: 'cornflowerblue' }}>{progress}%</p>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <CButton color="danger" onClick={() => setVisible(false)}>Cancelar</CButton>
          <CButton color="success" onClick={handleSubmit}>Guardar</CButton>
        </div>
      )}
    </>
  );
}

export default InsertRestaurante;
